
const breadcrumb = {

        addLink: (bc, url, text) => {
            bc = bc || '';
            if (bc.length > 0) bc = bc + ' > ';
            bc = bc + `<a href="${url}">${text}</a>`;
            return bc;
        },

        addText: (bc, text) => {
            bc = bc || '';
            if (bc.length > 0) bc = bc + ' > ';
            bc = bc + text;
            return bc;
        },

        create: (inputs) => {
            // creates a breadcrumb from scratch
            // inputs is an array of items to add
            // if array element has a url property, addLink is called
            // if array element has no url property, addText is called
            // example call:
            /*
                bc = common.breadcrumb.create([
                    { url: '/', text: 'UtterAccess' },
                    { url: '/boards/22, text: 'Board Name Here' },
                    { text: 'View Board' }
                ]);
            */
            var bc = '';
            for (var i = 0; i < inputs.length; i++) {
                var j = inputs[i];
                if (j.url) {
                    bc = breadcrumb.addLink(bc, j.url, j.text);
                } else {
                    bc = breadcrumb.addText(bc, j.text);
                }
            }
            return bc;
        }
};

const strings = {

    replaceAll: (str, find, replace) => {
        if (!str) return str;
        return str.replace(new RegExp(strings.escapeRegex(find), 'g'), replace);
    },

    escapeRegex: (str) => {
        if (!str) return str;
        // eslint-disable-next-line no-useless-escape
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    }
};

const uxUtil = {
    scrollToCenter(elementID) {
        process.nextTick(() => {
            document.getElementById(elementID).scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        });
    }
};

const common = {
    strings: strings,
    breadcrumb: breadcrumb,
    uxUtil: uxUtil
};




export default common;



